/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Один элемент подтверждения: идентификатор команды и lease-токен, выданный при claim
 * @export
 * @interface FxIdWebFeaturesClientCommandsAckAckItem
 */
export interface FxIdWebFeaturesClientCommandsAckAckItem {
    /**
     * Первичный ключ команды
     * @type {number}
     * @memberof FxIdWebFeaturesClientCommandsAckAckItem
     */
    Id: number;
    /**
     * Lease-токен, полученный при вызове /claim
     * @type {string}
     * @memberof FxIdWebFeaturesClientCommandsAckAckItem
     */
    LeaseToken: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesClientCommandsAckAckItem interface.
 */
export function instanceOfFxIdWebFeaturesClientCommandsAckAckItem(value: object): value is FxIdWebFeaturesClientCommandsAckAckItem {
    if (!('Id' in value) || value['Id'] === undefined) return false;
    if (!('LeaseToken' in value) || value['LeaseToken'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesClientCommandsAckAckItemFromJSON(json: any): FxIdWebFeaturesClientCommandsAckAckItem {
    return FxIdWebFeaturesClientCommandsAckAckItemFromJSONTyped(json, false);
}

export function FxIdWebFeaturesClientCommandsAckAckItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesClientCommandsAckAckItem {
    if (json == null) {
        return json;
    }
    return {
        
        'Id': json['Id'],
        'LeaseToken': json['LeaseToken'],
    };
}

export function FxIdWebFeaturesClientCommandsAckAckItemToJSON(json: any): FxIdWebFeaturesClientCommandsAckAckItem {
    return FxIdWebFeaturesClientCommandsAckAckItemToJSONTyped(json, false);
}

export function FxIdWebFeaturesClientCommandsAckAckItemToJSONTyped(value?: FxIdWebFeaturesClientCommandsAckAckItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Id': value['Id'],
        'LeaseToken': value['LeaseToken'],
    };
}

